import { Component, OnInit, ChangeDetectionStrategy, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/services/api.service';

@Component({
  selector: 'app-branches',
  templateUrl: './branches.html',
  styleUrls: ['./branches.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BranchesComponent implements OnInit {
  branches = signal<any[]>([]);
  company = signal<any>(null);
  loading = signal(true);
  error = signal('');
  companyId = '';

  constructor(private api: ApiService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    this.companyId = this.route.snapshot.paramMap.get('companyId') || '';
    this.api.getCompany(this.companyId).subscribe({
      next: (c) => this.company.set(c),
      error: () => {}
    });
    this.api.getBranches(this.companyId).subscribe({
      next: (data) => { this.branches.set(data); this.loading.set(false); },
      error: () => { this.error.set('Error al cargar sucursales'); this.loading.set(false); }
    });
  }

  goToDashboard(branch: any) {
    this.router.navigate(['/companies', this.companyId, 'branches', branch.idBranch, 'dashboard']);
  }

  goBack() {
    this.router.navigate(['/companies']);
  }
}
